import React, { useState, useEffect } from "react";
import { useParams } from "react-router";
import { Link } from "react-router-dom";
import Sidebar from "../../../partials/aside/Sidebar";
import TitleBar from "../../../partials/content/TitleBar";
import httpService from "../../../../services/httpServices/httpServices";
import helperNumber from "../../../../helpers/numbers";
import helperSpinner from "../../../../helpers/spinner";
import helperTime from "../../../../helpers/time";
import TypePageConstant from "./../TypePageConstant";
import PageConstants from "./PageConstants";

export default function AllPageSitePublisher() {
  const params = useParams();
  const publisherID = parseInt(params.publisherID);
  const [urlSitePublisher, setUrlSitePublisher] = useState("");
  const [allPageSitePublisher, setAllPageSitePublisher] = useState([]);

  useEffect(() => {
    getAllPageSitePublisher();
  }, []);

  useEffect(() => {
    if (allPageSitePublisher.length == 0) {
      return;
    }
    setUrlSitePublisherForHeaderPage();
  }, [allPageSitePublisher]);

  const getHeaderRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const getAllPageSitePublisher = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let allPageSitePublisher = await sendRequestGetAllPageSitePublisher(
      publisherID
    );
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!allPageSitePublisher) {
      return;
    }
    setAllPageSitePublisher(allPageSitePublisher.reverse());
  };

  const setUrlSitePublisherForHeaderPage = () => {
    let link = allPageSitePublisher[0].pap_link.replace("https://", "");
    link = link.replace("www.", "");
    !link.includes("/") && (link = link + "/");
    setUrlSitePublisher(link.split("/")[0]);
  };

  const sendRequestGetAllPageSitePublisher = async (publisherID) => {
    const headersRequest = getHeaderRequest();
    let pages;
    try {
      pages = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          `/v1/manage/publisher/${publisherID}/pages`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return pages.data.data;
  };

  const generateTagHtmlAllPageSitePublisher = () => {
    return (
      <>
        <div className="table-responsive">
          <table className="table table-hilite tbl-td-white-space">
            <thead>
              <tr>
                <td>#</td>
                <td>شماره</td>
                <td>عنوان </td>
                <td>الگوی آدرس</td>
                <td>لینک</td>
                <td>وضعیت</td>
                <td>حالت</td>
                <td>تاریخ درج</td>
                <td>تاریخ آخرین بروزرسانی</td>
                <td>عملیات</td>
              </tr>
            </thead>
            <tbody>
              {allPageSitePublisher.map((page, index) => {
                let classBadgeStatePage;
                switch (page.pap_state) {
                  case PageConstants.statusSiteUserPublisher.PENDING:
                    classBadgeStatePage = "badge-warning";
                    break;
                  case PageConstants.statusSiteUserPublisher.CONFIRM:
                    classBadgeStatePage = "badge-info";
                    break;
                  case PageConstants.statusSiteUserPublisher.REJECT:
                    classBadgeStatePage = "badge-danger";
                    break;
                  case PageConstants.statusSiteUserPublisher.REJECT_EDIT:
                    classBadgeStatePage = "badge-danger";
                    break;
                  case PageConstants.statusSiteUserPublisher.PENDING_EDIT:
                    classBadgeStatePage = "badge-warning";
                    break;
                }
                return (
                  <tr>
                    <td>{index + 1}</td>
                    <td>{page.pap_id}</td>
                    <td>
                      {page.pap_title}
                      {page.pap_pattern_url.includes("/@s") ? (
                        <span className="pr-2">
                          <span className="badge badge-success">
                            {
                              TypePageConstant.typePageString()[
                                TypePageConstant.typePage.MULTI_PAGE
                              ]
                            }
                          </span>
                        </span>
                      ) : (
                        <span className="pr-2">
                          <span className="badge badge-warning">
                            {
                              TypePageConstant.typePageString()[
                                TypePageConstant.typePage.STATIC
                              ]
                            }
                          </span>
                        </span>
                      )}
                    </td>
                    <td>
                      <div dir="ltr" className="text-left">
                        {page.pap_pattern_url}
                      </div>
                    </td>
                    <td>
                      <a
                        href={page.pap_link}
                        target="_blank"
                        className="btn btn-info"
                      >
                        <i className="fa fa-link"></i>
                      </a>
                    </td>
                    <td>
                      <span className={`badge ${classBadgeStatePage}`}>
                        {
                          PageConstants.getStatusSiteUserPublisherString()[
                            page.pap_state
                          ]
                        }
                      </span>
                    </td>
                    <td>
                      {page.pap_active ? (
                        <span className="badge badge-success">فعال</span>
                      ) : (
                        <span className="badge badge-danger">غیرفعال</span>
                      )}
                    </td>
                    <td>
                      {helperNumber.toPersianNum(
                        page.pap_created_at.split(" ")[1] +
                          " " +
                          helperTime.convertGregorianToJalali(
                            page.pap_created_at.split(" ")[0]
                          )
                      )}
                    </td>
                    <td>
                      {helperNumber.toPersianNum(
                        page.pap_updated_at.split(" ")[1] +
                          " " +
                          helperTime.convertGregorianToJalali(
                            page.pap_updated_at.split(" ")[0]
                          )
                      )}
                    </td>
                    <td>
                      <span className="pl-2">
                        <Link
                          to={`/position/manage/page/${page.pap_id}`}
                          className="btn btn-info"
                        >
                          نمایش جایگاه های
                        </Link>
                      </span>
                      <span>
                        <Link
                          to={`/page/manage/${page.pap_id}`}
                          className="btn btn-info"
                        >
                          <i className="fa fa-info"></i>
                        </Link>
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <hr />
      </>
    );
  };

  const generateTagHtmlDoNotHaveAnyPages = () => {
    return (
      <div className="alert alert-warning">
        این سایت نمایش دهنده در حال حاضر هیچ صفحه ای ندارد
      </div>
    );
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <TitleBar title={`صفحات سایت ${urlSitePublisher}`} />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <div className="text-left pb-2">
                <Link className="btn btn-primary" to="/publisher/manage/all">
                  <span>بازگشت</span>
                  <span className="pr-2">
                    <i className="fas fa-arrow-left"></i>
                  </span>
                </Link>
              </div>
              {allPageSitePublisher.length === 0
                ? generateTagHtmlDoNotHaveAnyPages()
                : generateTagHtmlAllPageSitePublisher()}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
